import * as log from "loglevel";

import IoTClient from "./iot-client";

/**
 * Update device client with AWS identity credentials after logging in.
 *
 * @param {object} awsCredentials - AWS SDK credentials
 * @param {string} awsCredentials.accessKeyId - Access Key Id
 * @param {string} awsCredentials.secretAccessKey - Secret Access Key
 * @param {string} awsCredentials.sessionToken - Session Token
 */
export const updateClientCredentials = (createNewClient = false, awsCredentials, options) => {
  const { accessKeyId, secretAccessKey, sessionToken } = awsCredentials;
  const client = new IoTClient(createNewClient, options);
  client.updateWebSocketCredentials(accessKeyId, secretAccessKey, sessionToken);
  return client;
};

export const initNewClient = config => {
  const options = {
    debug: config.mqttDebugLevel,
    accessKeyId: config.accessKeyId,
    secretKey: config.secretAccessKey,
    sessionToken: config.sessionToken,
    host: config.awsIotHost,
    region: "eu-west-1",
    clientId: config.clientId
  };
  const awsCredentials = {
    accessKeyId: config.accessKeyId,
    secretAccessKey: config.secretAccessKey,
    sessionToken: config.sessionToken
  };
  const client = updateClientCredentials(true, awsCredentials, options);
};

/**
 * Unsubscribe from topics
 *
 * @param {string[]} topics - List of topics to unsubscribe from
 */
export const unsubscribeFromTopics = topics => {
  const client = new IoTClient();

  topics.forEach(topic => {
    client.unsubscribe(topic);
  });
};

/**
 * Attach a message handler
 */
export const attachMessageHandler = handler => {
  const client = new IoTClient();
  client.attachMessageHandler(handler);
};

/**
 * Attach a connect handler
 *
 * @param {AWSIoT~onConnectHandler} onConnectHandler - Callback that handles a new connection
 *
 * @callback AWSIoT~onConnectHandler
 * @param {Object} connack - Connack object
 */
export const attachConnectHandler = () => {
  const client = new IoTClient();
  client.attachConnectHandler();
};

export const attachReconnectHandler = () => {
  const client = new IoTClient();
  client.attachReconnectHandler();
};

export const attachOfflineHandler = () => {
  const client = new IoTClient();
  client.attachOfflineHandler();
};

export const attachErrorHandler = () => {
  const client = new IoTClient();
  client.attachErrorHandler();
};

/**
 * Attach a close handler
 *
 * @param {AWSIoT~onCloseHandler} onCloseHandler - Callback that handles closing connection
 *
 * @callback AWSIoTI~onCloseHandler
 * @param {Object} err - Connection close error
 */
export const attachCloseHandler = () => {
  const client = new IoTClient();
  client.attachCloseHandler();
};

/**
 * Publish to an MQTT topic
 *
 * @param {string} topic - Topic to publish to
 * @param {string} message - JSON encoded payload to send
 */
export const publish = (topic, message) => {
  const client = new IoTClient();
  client.publish(topic, message);
};

/**
 * Subscribe to an MQTT topic
 *
 * @param {string} topic - Topic to subscribe to
 */
export const subscribe = topic => {
  const client = new IoTClient();
  try {
    client.subscribe(topic);
  } catch (err) {
    log.error("Not able to subscribe", err);
    throw err;
  }
};

export const endClient = () => {
  const client = new IoTClient();
  client.disconnect();
};

export const simulateNetworkFailure = () => {
  const client = new IoTClient();
  if (client) {
    client.simulateNetworkFailure();
  }
};
